import styles from './PublicationCarousel.module.css'

export default function PublicationCarousel() {

    const repeticoes = 5; // Defina o número de repetições desejado

    const containerPublicacoes = () => {
        const publicacoes = [];
        for (let i = 0; i < repeticoes; i++) {
            publicacoes.push(
                <div key={i}>
                    <div className={styles.title}>Titulo da publicação</div>
                    <div className={styles.font}>Disponível em: Lorem ipsum Lorem ipsum Lorem ipsum</div>
                    <br/>
                </div>
            );
        }
        return publicacoes;
    };
    
    return (
        <div className={styles.container}>
            {containerPublicacoes()}
        </div>
    );
}
